import { FC } from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { PositionRow } from "../../borrow/components/Position";
import { usePreloadedAccountData } from "../../services/accountData";
import { PositionsPortfolioFragment$key } from "./__generated__/PositionsPortfolioFragment.graphql";

const fragment = graphql`
  fragment PositionsPortfolioFragment on Account {
    credit {
      accounts {
        account {
          address
        }
        ...PositionBorrowRowFragment
      }
    }
  }
`;

export const Positions: FC = () => {
  const { accountData } = usePreloadedAccountData();
  const data = useFragment<PositionsPortfolioFragment$key>(
    fragment,
    accountData
  );
  return (
    <div className="relative card p-3 mt-2">
      {data?.credit.accounts?.length ? (
        <div className="table-sticky table-sticky--first">
          <table className="table table--big condensed portfolio__balances">
            <thead>
              <tr>
                <th>Deposited</th>
                <th>Borrowed</th>
                <th>Interest Rate</th>
                <th>LTV</th>
                <th>Liquidation Price</th>
                <th className="w-1" />
              </tr>
            </thead>
            <tbody>
              {data?.credit.accounts?.map((a) => (
                <PositionRow
                  k={a}
                  key={a.account.address}
                  adjustmentThreshold={1n}
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="condensed fs-14 color-grey text-center mt-2">
          You have no open borrowing positions
        </p>
      )}
    </div>
  );
};
